<!--A place holder page used while we are still under construction-->

<template>
  <div>
    <mdb-view>
      <mdb-mask class="d-flex justify-content-center align-items-center">
        <mdb-container fluid>
          <mdb-row>
            <mdb-col md="8" class="mt-xl-5">
              <img :src="require('@/assets/gunner4044.png')" class="img-fluid animated bounceIn" />
            </mdb-col>
            <div class="black-text text-center text-md-left col-md-4 mt-xl-5 pt-xl-5 mb-5">
              <h1
                class="h1-responsive font-weight-bold mt-sm-5"
              >Oops! We couldn't find the page you were looking for.</h1>
              <hr class="hr-light" />
              <h6 class="mb-4">Click below to go back to the homepage.</h6>
              <a href="/">
                <mdb-btn color="black">Home</mdb-btn>
              </a>
            </div>
          </mdb-row>
        </mdb-container>
      </mdb-mask>
    </mdb-view>
  </div>
</template>

<script>
import { mdbBtn, mdbView, mdbMask, mdbContainer, mdbRow, mdbCol } from "mdbvue";
export default {
  name: "ComingSoon",
  components: {
    mdbBtn,
    mdbView,
    mdbMask,
    mdbContainer,
    mdbRow,
    mdbCol,
  },
  props: {
    slug: String,
  },
  data() {
    return {
      page: String,
      loading: true,
    };
  },
  mounted() {},
  methods: {
    getData: function () {},
  },
  watch: {
    slug: function () {
      // watch it
    },
  },
};
</script>
<style scoped>
.view {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-color: #2c87b3;
  height: calc(100vh - 60px);
}
.gradient {
  background: -moz-linear-gradient(
    45deg,
    rgba(42, 27, 161, 0.7),
    rgba(29, 210, 177, 0.7) 100%
  );
  background: -webkit-linear-gradient(
    45deg,
    rgba(42, 27, 161, 0.7),
    rgba(29, 210, 177, 0.7) 100%
  );
  background: -webkit-gradient(
    linear,
    45deg,
    from(rgba(42, 27, 161, 0.7)),
    to(rgba(29, 210, 177, 0.7))
  );
  background: -o-linear-gradient(
    45deg,
    rgba(42, 27, 161, 0.7),
    rgba(29, 210, 177, 0.7) 100%
  );
  background: linear-gradient(
    45deg,
    rgba(42, 27, 161, 0.7),
    rgba(29, 210, 177, 0.7) 100%
  );
}
h6 {
  line-height: 1.7;
}
</style>
